export type HttpMethod = 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH';

export const getHttpMethodColor = (method: HttpMethod): string => {
    switch (method) {
        case 'GET':
            return '#319674ff'; 
        case 'POST':
            return '#f9bd54ff'; 
        case 'DELETE':
            return '#ec5858ff'; 
        case 'PUT':
            return '#9bbff9ff'; 
        case 'PATCH':
            return '#baa1f2ff'; 
        default:
            return '#6b7280';
    }
};
export interface ApiEndpoint {
    apiName: string;
    navigationId: string;
    method: HttpMethod;
}
